import {GitHubAvatar} from '@github-ui/github-avatar'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ownerPath, teamPath} from '@github-ui/paths'
import {Link as PrimerLink} from '@primer/react'
import type {Reviewer} from '../../../page-data/payloads/review-requests'
import styles from './Reviewers.module.css'

export function ReviewerIdentity({
  reviewer,
  withAvatar = true,
  withLeadingAt = false,
}: {
  reviewer: Reviewer
  withAvatar?: boolean
  withLeadingAt?: boolean
}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  const isTeam = reviewer.reviewerType === 'Team'
  const hovercardAttrs = isTeam
    ? getHovercardAttributesForType('team', {
        owner: reviewer.organizationLogin ?? '',
        team: reviewer.displayLogin,
      })
    : getHovercardAttributesForType('user', {login: reviewer.displayLogin})

  return (
    <PrimerLink href={reviewerHref(reviewer)} muted className={styles.reviewerIdentity} {...hovercardAttrs}>
      {withAvatar && <GitHubAvatar src={reviewer.avatarUrl} size={20} square={isTeam} />}
      <span className={styles.reviewerName}>
        {withLeadingAt && <span>@</span>}
        {reviewer.displayLogin}
      </span>
    </PrimerLink>
  )
}

function reviewerHref(reviewer: Reviewer): string {
  if (reviewer.reviewerType === 'Team' && reviewer.organizationLogin) {
    return teamPath({owner: reviewer.organizationLogin, team: reviewer.displayLogin})
  }
  return ownerPath({owner: reviewer.displayLogin})
}
